<script setup lang="ts">
import type { Props } from './types';

defineProps<Props>();
</script>

<template>
	<div
		:class="{
			'top-tagSelector_tagIcon': true,
			'top-tagSelector-active': !!state,
			'top-tagSelector-excluded': state === 'excluded',
		}"
		:data-tag_id="id"
		:data-tag_color_id="colorId"
		:title="name"
	></div>
</template>

<style>
[data-tag_id] { display: inline-flex; gap: var(--top-gap-2); align-items: center; }

[data-tag_id=""] { border-color: #bdc3c7 !important; color: #55555F !important; }
[data-tag_color_id="1"] { border-color: var(--color-tag-1) !important; color: #55555F !important; }
[data-tag_color_id="2"] { border-color: var(--color-tag-2) !important; color: var(--color-tag-2) !important; }
[data-tag_color_id="3"] { border-color: var(--color-tag-3) !important; color: var(--color-tag-3) !important; }
[data-tag_color_id="4"] { border-color: var(--color-tag-4) !important; color: var(--color-tag-4) !important; }
[data-tag_color_id="5"] { border-color: var(--color-tag-5) !important; color: var(--color-tag-5) !important; }
[data-tag_color_id="6"] { border-color: var(--color-tag-6) !important; color: var(--color-tag-6) !important; }
[data-tag_color_id="7"] { border-color: var(--color-tag-7) !important; color: var(--color-tag-7) !important; }
[data-tag_color_id="8"] { border-color: var(--color-tag-8) !important; color: var(--color-tag-8) !important; }
[data-tag_color_id="9"] { border-color: var(--color-tag-9) !important; color: var(--color-tag-9) !important; }
[data-tag_color_id="10"] { border-color: var(--color-tag-10) !important; color: var(--color-tag-10) !important; }

[data-tag_id=""].top-tagSelector-active { background: #bdc3c7 !important; }
[data-tag_color_id="1"].top-tagSelector-active { background: var(--color-tag-1) !important; }
[data-tag_color_id="2"].top-tagSelector-active { background: var(--color-tag-2) !important; }
[data-tag_color_id="3"].top-tagSelector-active { background: var(--color-tag-3) !important; }
[data-tag_color_id="4"].top-tagSelector-active { background: var(--color-tag-4) !important; }
[data-tag_color_id="5"].top-tagSelector-active { background: var(--color-tag-5) !important; }
[data-tag_color_id="6"].top-tagSelector-active { background: var(--color-tag-6) !important; }
[data-tag_color_id="7"].top-tagSelector-active { background: var(--color-tag-7) !important; }
[data-tag_color_id="8"].top-tagSelector-active { background: var(--color-tag-8) !important; }
[data-tag_color_id="9"].top-tagSelector-active { background: var(--color-tag-9) !important; }
[data-tag_color_id="10"].top-tagSelector-active { background: var(--color-tag-10) !important; }

[data-tag_id="all"] {
	border-color: transparent !important; background: none !important;
}

[data-tag_id="all"]:before {
	content: "";
	color: var(--color-tag-all) !important;
	font-size: 26px;
	min-width: calc(100% + 4px);
	height: calc(100% + 4px);
	margin-top: -18px;
	margin-left: -8px;
}

/* в кнопке выбора тэгов и в popup */
.top-tagSelector-useTopButton [data-tag_id],
.top-tagSelector_popup [data-tag_id] {
	--top-tag-selector-size: 10px;

	box-sizing: content-box;
	border-radius: 100%; border: 2px solid var(--color-layout-front-1); background: var(--color-layout-front-1);
	width: var(--top-tag-selector-size);
	height: var(--top-tag-selector-size);
	font-size: calc(var(--top-tag-selector-size) + 4px);
	/*font-family: inherit !important;*/
}

/* исключение тегов */
.top-body-press_ctrl .top-tagSelector_tagListItem-canExclude:hover [data-tag_id],
[data-tag_id].top-tagSelector-excluded { position: relative; }

.top-body-press_ctrl .top-tagSelector_tagListItem-canExclude:hover [data-tag_id]:before,
[data-tag_id].top-tagSelector-excluded:before {
	content: "";
	width: calc(var(--top-tag-selector-size) * 2); height: 1px; background: inherit;
	transform: rotate(-45deg); filter: brightness(80%);
	display: block;
	position: absolute; top: calc(var(--top-tag-selector-size) / 2); left: calc(0px - var(--top-tag-selector-size) / 2);
}
.top-body-press_ctrl .top-tagSelector_tagListItem-canExclude:hover [data-tag_id]:not([data-tag_id="all"]):not(.top-tagSelector-active):before { background: #AAA; }
[data-tag_id].top-tagSelector-excluded:after,
[data-tag_id].top-tagSelector-excluded ~ .top-tagSelector_tagListItemName { text-decoration: line-through; }

/* popup */
.top-popup_listItem.top-tagSelector-active { background: var(--top-popup-background-color-active) !important; }

.top-popup_listItem:hover [data-tag_id="all"]:before { border-color: var(--top-popup-background-color-hover); }
.top-popup_listItem.top-tagSelector-active [data-tag_id="all"]:before,
.top-popup_listItem.top-active [data-tag_id="all"]:before { border-color: var(--top-popup-background-color-active); }
</style>
